import type { Doc } from "building-types/doc";
import type { RuleBasedSelectorHandle, ViewTemplateOverrideHandle } from "building-types/handles/docEntityHandleTypes";
import type { RuleBasedSelector, RuleBasedSelectorInstance } from "building-types/selectors/ruleBasedSelectorTypes";
import type { Table } from "common/data/table";
import objectFilter from "common/utils/objectFilter";

export function docGetRuleBasedSelectorsFromHandle(
  doc: Pick<Doc, "ruleBasedSelectors" | "ruleBasedSelectorInstances">,
  handle: ViewTemplateOverrideHandle,
): Table<RuleBasedSelector> {
  const selectors = {};

  for (const instanceId in doc.ruleBasedSelectorInstances) {
    const instance = doc.ruleBasedSelectorInstances[instanceId];
    if (instance.parentId === handle.id) {
      const selector = doc.ruleBasedSelectors[instance.selectorId];
      if (!selector) {
        continue;
      }
      selectors[instance.selectorId] = doc.ruleBasedSelectors[instance.selectorId];
    }
  }

  return selectors;
}

export function docGetRuleBasedSelectorsFromInstances(
  doc: Pick<Doc, "ruleBasedSelectors">,
  instances: Table<RuleBasedSelectorInstance>,
): Table<RuleBasedSelector> {
  const selectors = {};

  for (const id in instances) {
    const instance = instances[id];
    const selector = doc.ruleBasedSelectors[instance.selectorId];
    if (!selector) {
      continue;
    }
    selectors[instance.selectorId] = selector;
  }

  return selectors;
}

export function docGetRuleBasedSelectorInstancesFromHandle(
  doc: Pick<Doc, "ruleBasedSelectorInstances">,
  handle: RuleBasedSelectorHandle | ViewTemplateOverrideHandle,
): Table<RuleBasedSelectorInstance> {
  const fieldName: keyof RuleBasedSelectorInstance = handle.type === "RULE_BASED_SELECTOR" ? "selectorId" : "parentId";
  return objectFilter(doc.ruleBasedSelectorInstances, (instance) => instance[fieldName] === handle.id);
}
